export default "__VITE_ASSET__UHw5Wk_8__"